@if (!isLoading) {
  <div class="container period-selection-container">
    <div class="row">
      <div class="col col-12">
        <p class="annualize-periods-form-header">Select a monthly, quarterly, semi-annual, or YTD period to create
        an annualize statement from</p>
      </div>
    </div>
    <div class="row">
      <div class="col col-12">
        <label for="referenceFrameSelect">Select Period to Annualize</label>
        <div [class.is-invalid]="isFieldInvalid('referencePeriod')">
          <app-select2
            id="referenceFrameSelect"
            placeholder="Select"
            [data]="periodOptions"
            [options]="{minimumResultsForSearch: -1}"
            [value]="selectedReferenceFrameIndex"
            (valueChanged)="updateSelectedReferenceFrameIndex($event.value)"
            [width]="'100%'"
            >
          </app-select2>
        </div>
        @if (isFieldInvalid('referencePeriod')) {
          <div class="invalid-feedback">
            Please select a period to annualize.
          </div>
        }
      </div>
    </div>
    <div class="row">
      <div class="col col-12">
        <p class="add-annualized-period-information-text">Add annualized period information</p>
      </div>
    </div>
    <div class="row">
      <div class="col col-6 scenario-type-col">
        <label for="scenarioTypeSelect">Scenario Type</label>
        <div [class.is-invalid]="isFieldInvalid('scenarioType')">
          <app-select2
            id="scenarioTypeSelect"
            placeholder="Select"
            [data]="scenarioTypeOptions"
            [options]="{minimumResultsForSearch: -1}"
            [value]="scenarioType"
            (valueChanged)="updateScenarioType($event.value)"
            [width]="'100%'"
            >
          </app-select2>
        </div>
        @if (isFieldInvalid('scenarioType') && !isDuplicateAnnualizedPeriod()) {
          <div class="invalid-feedback">
            Please select a Scenario Type.
          </div>
        }
      </div>
      <div class="col col-6 scenario-name-col">
        <label for="scenarioName">Scenario Name</label>
        <input
          type="text"
          id="scenarioName"
          class="form-control"
          [class.is-invalid]="isFieldInvalid('scenarioName')"
          placeholder="Scenario Name"
          [value]="scenarioName"
          (input)="updateScenarioName($event.target.value)">
        @if (getScenarioNameError(); as errMsg) {
          <div class="invalid-feedback">
            {{ errMsg }}
          </div>
        }
      </div>
    </div>
    @if (isDuplicateAnnualizedPeriod()) {
      <div class="row">
        <div class="col col-12">
          <div class="invalid-feedback duplicate-period-error">
            An annualized period with this scenario type and scenario name already exists for this statement date. Please change one or more fields.
          </div>
        </div>
      </div>
    }
    <div class="row footer">
      <div class="col col-12 footer-col">
        <div class="footer-content">
          <div class="error-message-container">
            @if (wasValidated && !isFormComplete) {
              <span class="validation-error-message">Please resolve error(s)</span>
            }
          </div>
          <div class="button-container">
            <button class="btn btn-link" (click)="triggerCloseGeneratePeriods()">Cancel</button>
            <button class="btn btn-primary" (click)="handleGenerateAnnualizedPeriod()" [disabled]="isSubmitting">
              <span class="build-statement-btn-label">Build Statement</span>
              @if (isSubmitting) {
                <div class="loader button-loader build-statement-btn-icon"></div>
              }
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
} @else {
  <div class="loading-panel-container loader__container">
    <div class="loader"></div>
  </div>
}


